<template lang="pug">
  v-rating(
    v-bind="$data.$_attrs"
    v-on="$data.$_listeners"
  )
    template(v-slot:item="props")
      k-icon(
        :size="starSize"
        :color="props.isFilled || props.isHalfFilled ? 'brand-dark-aqua' : '#DBF2F3'"
      ).pa-0 {{ props.isHalfFilled ? 'ratingHalfFilled' : 'ratingFull' }}

</template>

<script>
import { BindsAttrs } from '@/mixins'
export default {
  mixins: [ BindsAttrs ],
  props: {
    starSize: {
      default: 14,
      type: Number
    }
  }
}
</script>

<style scoped lang="scss">
// v-rating adds a border radius for some reason so remove it
.v-rating .v-icon {
  border-radius: 0;
}
</style>
